import React from 'react';
import VerbHeading from '../../../shared/components/VerbHeading';
import VerbParagraph from '../../../shared/components/VerbParagraph';

const HomeWelcomeBanner = () => (
    <div className={`home-welcome-banner`}>
        <div className={'container'}>
            <div className={'header-container'}>
                <VerbHeading hNumber={5} messageId={'WELCOME_TO_VERB'} defaultMessage={'Welcome to Verb'} />
            </div>
            <div className={'welcome-paragraph'}>
                <VerbParagraph
                    messageId={'HOME_WELCOME_DEVELOP_YOURSELF'}
                    defaultMessage={
                        'Develop yourself as a human-centered leader and solve everyday workplace challenges through bite-sized learning.'
                    }
                />
                <br />
                <div className={'welcome-paragraph'}>
                    <VerbParagraph
                        messageId={'HOME_WELCOME_BROWSE_COLLECTIONS'}
                        defaultMessage={
                            'Our collections allow you to master skills through experiential learning activities. Browse the featured collections below to begin your personalized learning journey.'
                        }
                    />
                </div>
            </div>
        </div>
    </div>
);

export default HomeWelcomeBanner;
